var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemographicInfoBlackFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.8625H9.9975C8.6625 9.8625 7.575 8.7825 7.575 7.44V5.8125C7.575 5.505 7.3275 5.25 7.0125 5.25H4.635C2.9025 5.25 1.5 6.375 1.5 8.385V13.365C1.5 15.375 2.9025 16.5 4.635 16.5H9.0525C10.785 16.5 12.1875 15.375 12.1875 13.365V10.425C12.1875 10.11 11.9325 9.8625 11.625 9.8625Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3648 1.5H11.8873H11.0698H8.94732C7.25232 1.5 5.87982 2.58 5.81982 4.5075C5.86482 4.5075 5.90232 4.5 5.94732 4.5H8.06982H8.88732H10.3648C12.0973 4.5 13.4998 5.625 13.4998 7.635V9.1125V11.145V12.6225C13.4998 12.6675 13.4923 12.705 13.4923 12.7425C15.1648 12.69 16.4998 11.58 16.4998 9.6225V8.145V6.1125V4.635C16.4998 2.625 15.0973 1.5 13.3648 1.5Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98498 5.36231C8.75248 5.12981 8.35498 5.28731 8.35498 5.60981V7.57481C8.35498 8.39981 9.05248 9.07481 9.90748 9.07481C10.44 9.08231 11.1825 9.08231 11.82 9.08231C12.1425 9.08231 12.3075 8.70731 12.0825 8.48231C11.265 7.66481 9.80998 6.20231 8.98498 5.36231Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemographicInfoBlackFilled);
export default __webpack_public_path__ + "static/media/demographic_info_black_filled.23bf8086f0b51b3604e7defc3970b6bd.svg";
export { ForwardRef as ReactComponent };